(function () {
  'use strict';

  document.querySelectorAll('[id^="product-options-modal-"]').forEach(initProductOptionsModal);

  function initProductOptionsModal(modal) {
    var productId = modal.dataset.productId;
    var debugEl = document.getElementById('po-debug-' + productId);
    var debugData = null;

    if (debugEl) {
      try {
        debugData = JSON.parse(debugEl.textContent.trim());
      } catch (e) {
        console.error('[product-options] JSON parse error', e, debugEl.textContent);
      }
      console.log('[product-options] metaobject dump', debugData);
    }

    var steps = Array.from(modal.querySelectorAll('.po-step'));
    if (!steps.length) {
      console.warn('[product-options] metafield present but no known option type was rendered', debugData);
    }

    var addBtn = modal.querySelector('#po-add-to-cart');
    var priceEl = modal.querySelector('#po-price');
    var qtyInput = modal.querySelector('#po-quantity');
    var variantInput = modal.querySelector('#po-variant-id');
    var progressBar = modal.querySelector('.po-progress__bar');
    var progressWrap = modal.querySelector('.po-progress');
    var prevBtn = modal.querySelector('[data-po-prev]');
    var nextBtn = modal.querySelector('[data-po-next]');
    var recapEl = modal.querySelector('.po-recap');
    var recapList = modal.querySelector('[data-po-recap-list]');
    var priceOne = modal.dataset.priceOne || '';
    var priceTwo = modal.dataset.priceTwo || '';
    var labelYes = modal.dataset.labelYes || 'Oui';
    var labelNo = modal.dataset.labelNo || 'Non';
    var labelFree = modal.dataset.labelFree || 'Inclus';
    var recapLot = modal.dataset.recapLot || '';
    var recapPoignee = modal.dataset.recapPoignee || recapLot;
    var recapCarre = modal.dataset.recapCarre || '';
    var recapPlaque = modal.dataset.recapPlaque || '';
    var recapPlaqueType = modal.dataset.recapPlaqueType || '';
    var recapWith = modal.dataset.recapWith || 'Avec';
    var recapWithout = modal.dataset.recapWithout || 'Sans';
    var recapDash = modal.dataset.recapDash || '—';
    var productTitle = modal.dataset.productTitle || '';
    var productImage = modal.dataset.productImage || '';
    var soldAsPair = modal.dataset.soldAsPair === 'true';
    var soldAsPairLabel = modal.dataset.soldAsPairLabel || '';
    var unitCents = parseInt(modal.dataset.unitCents, 10) || 0;
    var moneyFormat = modal.dataset.moneyFormat || '';

    var current = 0;
    var answers = {};
    var advanceTimer = null;
    var showingRecap = false;

    function showBtn(btn, visible) {
      if (!btn) return;
      btn.classList.toggle('opacity-0', !visible);
      btn.classList.toggle('pointer-events-none', !visible);
      btn.tabIndex = visible ? 0 : -1;
    }

    function plaqueTypeButtons() {
      var typeStep = steps.find(function (s) { return s.dataset.poType === 'plaque-type'; });
      if (!typeStep) return [];
      return Array.from(typeStep.querySelectorAll('.po-radio'));
    }

    function hasSinglePlaqueType() {
      return plaqueTypeButtons().length === 1;
    }

    function isSkipped(step) {
      if (!step || !step.dataset.poRequires) return false;
      if (step.dataset.poType === 'plaque-type' && hasSinglePlaqueType()) return true;
      if (step.dataset.poRequires === 'plaque-yes') {
        var plaque = steps.find(function (s) { return s.dataset.poType === 'plaque'; });
        if (!plaque) return false;
        return answers[steps.indexOf(plaque)] === 'no';
      }
      if (step.dataset.poRequires === 'lot-yes') {
        var lot = steps.find(function (s) { return s.dataset.poType === 'lot-de-2'; });
        if (!lot) return false;
        return answers[steps.indexOf(lot)] !== 'yes';
      }
      if (step.dataset.poRequires === 'addon-yes') {
        var askIndex = parseInt(step.dataset.poAskStep, 10);
        if (isNaN(askIndex)) return false;
        return answers[askIndex] !== 'yes';
      }
      return false;
    }

    function visibleStepIndexes() {
      return steps.reduce(function (acc, step, i) {
        if (!isSkipped(step)) acc.push(i);
        return acc;
      }, []);
    }

    function allAnswered() {
      var vis = visibleStepIndexes();
      if (!vis.length) return false;
      return vis.every(function (i) {
        return answers.hasOwnProperty(i);
      });
    }

    function answeredCount() {
      return visibleStepIndexes().filter(function (i) {
        return answers.hasOwnProperty(i);
      }).length;
    }

    function lotIsYes() {
      if (soldAsPair) return true;
      return steps.some(function (step, i) {
        return step.dataset.poType === 'lot-de-2' && answers[i] === 'yes';
      });
    }

    function productQty() {
      return 1;
    }

    function addonQty() {
      return lotIsYes() ? 2 : 1;
    }

    function extraQty(step) {
      if (step && step.dataset.poType === 'plaque-variant') return addonQty();
      return 1;
    }

    function extraCents() {
      var extra = 0;
      steps.forEach(function (step, i) {
        if (isSkipped(step) || !answers.hasOwnProperty(i)) return;
        var val = answers[i];
        if (!val || typeof val !== 'object') return;
        extra += (parseInt(val.cents, 10) || 0) * extraQty(step);
      });
      return extra;
    }

    function formatMoney(cents) {
      var amount = (Math.abs(cents) / 100).toFixed(2);
      var withComma = amount.replace('.', ',');
      var noDecimals = String(Math.round(Math.abs(cents) / 100));
      if (!moneyFormat) return amount;
      return moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    function priceLabel(cents, qty) {
      qty = qty || 1;
      var total = (parseInt(cents, 10) || 0) * qty;
      if (total === 0) return labelFree;
      return '+' + formatMoney(total);
    }

    function updateProgress() {
      var vis = visibleStepIndexes();
      var total = vis.length;
      var pct = 0;
      if (showingRecap) {
        pct = 100;
      } else if (total > 0) {
        var pos = vis.indexOf(current);
        if (pos < 0) pos = 0;
        pct = Math.round((pos / total) * 100);
      }
      if (progressBar) {
        progressBar.style.width = pct + '%';
      }
      if (progressWrap) progressWrap.setAttribute('aria-valuenow', String(pct));
    }

    function plaqueQtyName(name, qty) {
      name = name || '';
      if (qty > 1) {
        if (!/plaques/i.test(name)) {
          name = name.replace(/\bplaque\b/gi, function (word) {
            return word + 's';
          });
        }
        return name;
      }
      return name.replace(/\bplaques\b/gi, function (word) {
        return word.slice(0, -1);
      });
    }

    function updateQtySensitiveLabels() {
      var qty = addonQty();
      modal.querySelectorAll('[data-po-qty-sensitive]').forEach(function (opt) {
        var prefix = opt.querySelector('.po-dropdown__qty-prefix');
        var priceNode = opt.querySelector('.po-dropdown__option-price');
        var cents = parseInt(opt.dataset.poCents, 10) || 0;
        if (prefix) prefix.hidden = qty < 2;
        if (!priceNode) return;
        priceNode.textContent = priceLabel(cents, qty);
      });
      var chooseTpl = qty > 1
        ? (modal.dataset.plaqueChoose || '')
        : (modal.dataset.plaqueChooseOne || '');
      modal.querySelectorAll('[data-po-plaque-choose]').forEach(function (el) {
        var name = plaqueQtyName(el.dataset.poName || '', qty);
        if (!chooseTpl) return;
        el.textContent = chooseTpl.replace(/__NAME__/g, name);
      });
      updateFilledTriggers();
    }

    function setDropdownValue(dd, label, priceText) {
      if (!dd) return;
      var placeholder = dd.querySelector('.po-dropdown__placeholder');
      var selected = dd.querySelector('.po-dropdown__selected');
      var valueEl = dd.querySelector('.po-dropdown__value');
      var priceNode = dd.querySelector('.po-dropdown__price');
      if (placeholder) placeholder.hidden = true;
      if (selected) selected.hidden = false;
      if (valueEl) valueEl.textContent = label || '';
      if (priceNode) {
        priceNode.textContent = priceText || '';
        priceNode.hidden = !priceText;
      }
      dd.classList.add('has-value');
    }

    function clearDropdownValue(dd) {
      if (!dd) return;
      dd.classList.remove('has-value');
      var placeholder = dd.querySelector('.po-dropdown__placeholder');
      var selected = dd.querySelector('.po-dropdown__selected');
      var valueEl = dd.querySelector('.po-dropdown__value');
      var priceNode = dd.querySelector('.po-dropdown__price');
      if (placeholder) placeholder.hidden = false;
      if (selected) selected.hidden = true;
      if (valueEl) valueEl.textContent = '';
      if (priceNode) {
        priceNode.textContent = '';
        priceNode.hidden = true;
      }
    }

    function updateFilledTriggers() {
      var qty = addonQty();
      steps.forEach(function (step, i) {
        if (!answers.hasOwnProperty(i)) return;
        var a = answers[i];
        if (!a || typeof a !== 'object') return;
        var dd = step.querySelector('.po-dropdown.has-value:not([hidden])') ||
          step.querySelector('.po-dropdown.has-value');
        if (!dd) return;
        var selectedOpt = dd.querySelector('.po-dropdown__option.is-selected');
        var priceText = '';
        if (a.value === 'none') {
          priceText = '';
        } else if (selectedOpt) {
          var priceNode = selectedOpt.querySelector('.po-dropdown__option-price');
          priceText = priceNode ? priceNode.textContent : '';
        } else {
          priceText = priceLabel(a.cents, step.dataset.poType === 'plaque-variant' ? qty : 1);
        }
        var label = a.label || '';
        if (qty > 1 && step.dataset.poType === 'plaque-variant') label = '2 x ' + label;
        setDropdownValue(dd, label, priceText);
      });
    }

    function answerLabel(step, value) {
      if (typeof value === 'string') {
        if (value === 'yes') return labelYes;
        if (value === 'no') return labelNo;
        return value;
      }
      if (value && value.label) {
        var qty = addonQty();
        if (qty > 1 && step && step.dataset.poType === 'plaque-variant') {
          return '2 x ' + value.label;
        }
        return value.label;
      }
      return '';
    }

    function stepRecapName(step) {
      return (step && step.dataset.poRecapName) || recapCarre;
    }

    function collectProperties() {
      var props = {};
      var qty = addonQty();
      if (soldAsPair && soldAsPairLabel) {
        props[soldAsPairLabel] = recapWith;
      }
      steps.forEach(function (step, i) {
        if (isSkipped(step) || !answers.hasOwnProperty(i)) return;
        var type = step.dataset.poType;
        var a = answers[i];
        if (type === 'lot-de-2') {
          props[recapLot] = a === 'yes' ? recapWith : recapWithout;
        }
        if (type === 'lot-handle' && a && a.label) {
          props[a.label] = a.label;
        }
        if (type === 'addon-ask' && a === 'no') {
          props[stepRecapName(step)] = recapWithout;
        }
        if (type === 'carre') {
          var carreName = stepRecapName(step);
          if (a && a.variantId) props[carreName] = a.label || '';
          else props[carreName] = recapWithout;
        }
        if (type === 'plaque') {
          props[recapPlaque] = a === 'yes' ? recapWith : recapWithout;
        }
        if (type === 'plaque-type' && a && a.label) {
          props[recapPlaqueType] = shortPlaqueType(a.label);
        }
        if (type === 'plaque-variant' && a && a.variantId) {
          var plaqueName = a.label || '';
          if (qty > 1) plaqueName = plaqueName + ' x' + qty;
          props[recapPlaque] = plaqueName;
        }
      });
      return props;
    }

    function extraItems(qty, bundleId) {
      var items = [];
      var parentTitle = modal.dataset.productTitle || '';
      var addonFor = modal.dataset.addonFor || '';
      steps.forEach(function (step, i) {
        if (isSkipped(step) || !answers.hasOwnProperty(i)) return;
        var val = answers[i];
        if (!val || !val.variantId) return;
        var extraProps = {
          _po_addon: '1',
          _po_bundle: bundleId
        };
        if (step.dataset.poType === 'lot-handle') extraProps._po_kind = 'lot-handle';
        if (step.dataset.poType === 'plaque-variant') extraProps._po_kind = 'plaque';
        if (addonFor && parentTitle) extraProps[addonFor] = parentTitle;
        items.push({
          id: Number(val.variantId),
          quantity: extraQty(step),
          properties: extraProps
        });
      });
      return items;
    }

    function updateFooter() {
      var qty = productQty();
      var extra = extraCents();
      var total = unitCents * qty + extra;

      if (priceEl) {
        if (extra === 0 && qty === 1) priceEl.textContent = priceOne;
        else if (extra === 0 && qty === 2) priceEl.textContent = priceTwo;
        else priceEl.textContent = formatMoney(total);
      }
      if (qtyInput) qtyInput.value = String(qty);
      if (addBtn) addBtn.disabled = !(allAnswered() && showingRecap);
      updateQtySensitiveLabels();
    }

    function closeAllDropdowns() {
      modal.querySelectorAll('.po-dropdown').forEach(function (dd) {
        dd.classList.remove('is-open');
        var list = dd.querySelector('.po-dropdown__list');
        var trigger = dd.querySelector('.po-dropdown__trigger');
        if (list) list.hidden = true;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function resetDropdownUI(root) {
      (root || modal).querySelectorAll('.po-dropdown').forEach(function (dd) {
        dd.classList.remove('is-open');
        var list = dd.querySelector('.po-dropdown__list');
        var trigger = dd.querySelector('.po-dropdown__trigger');
        if (list) list.hidden = true;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        clearDropdownValue(dd);
        dd.querySelectorAll('.po-dropdown__option').forEach(function (opt) {
          opt.classList.remove('is-selected');
        });
      });
    }

    function syncPlaqueVariantDropdowns() {
      var typeStep = steps.find(function (s) { return s.dataset.poType === 'plaque-type'; });
      var variantStep = steps.find(function (s) { return s.dataset.poType === 'plaque-variant'; });
      if (!variantStep) return;
      var selectedId = '';
      if (typeStep) {
        var typeAnswer = answers[steps.indexOf(typeStep)];
        selectedId = typeAnswer && typeAnswer.productId ? String(typeAnswer.productId) : '';
      }
      variantStep.querySelectorAll('[data-po-plaque-product]').forEach(function (dd) {
        var match = selectedId !== '' && dd.dataset.poPlaqueProduct === selectedId;
        dd.hidden = !match;
        if (!match) {
          dd.classList.remove('is-open');
          var list = dd.querySelector('.po-dropdown__list');
          var trigger = dd.querySelector('.po-dropdown__trigger');
          if (list) list.hidden = true;
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function hideRecap() {
      showingRecap = false;
      modal.classList.remove('is-recap');
      if (recapEl) {
        recapEl.hidden = true;
        recapEl.classList.remove('is-active');
      }
    }

    function showStep(index) {
      hideRecap();
      var vis = visibleStepIndexes();
      if (vis.indexOf(index) === -1) {
        index = vis.length ? vis[0] : 0;
      }
      current = Math.max(0, Math.min(index, Math.max(steps.length - 1, 0)));
      closeAllDropdowns();
      syncPlaqueVariantDropdowns();
      steps.forEach(function (step, i) {
        step.classList.toggle('is-active', i === current && !isSkipped(step));
      });
      var pos = vis.indexOf(current);
      showBtn(prevBtn, pos > 0);
      showBtn(nextBtn, answers.hasOwnProperty(current) && pos !== -1 && (pos < vis.length - 1 || allAnswered()));
      updateProgress();
      updateFooter();
    }

    function shortPlaqueType(title) {
      if (!title) return '';
      return title
        .replace(/^\s*plaques?\s+de\s+porte\s+/i, '')
        .replace(/^\s*door\s+plates?\s+/i, '')
        .replace(/^\s*door\s+plate\s+/i, '') || title;
    }

    function recapRow(opts) {
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'po-recap__row' + (opts.image ? ' po-recap__row--media' : '');
      if (opts.goto != null) row.dataset.poGoto = String(opts.goto);

      if (opts.image) {
        var wrap = document.createElement('span');
        wrap.className = 'po-dropdown__thumb-wrap';
        var img = document.createElement('img');
        img.className = 'po-dropdown__thumb';
        img.src = opts.image;
        img.alt = opts.name || '';
        img.width = 79;
        img.height = 96;
        wrap.appendChild(img);
        row.appendChild(wrap);
      }

      var name = document.createElement('span');
      name.className = 'po-recap__name md:text-d-p text-m-p';
      name.textContent = opts.name || '';
      row.appendChild(name);

      var meta = document.createElement('span');
      meta.className = 'po-recap__meta';
      if (opts.choice) {
        var choice = document.createElement('span');
        choice.className = 'po-recap__choice' + (opts.keepCase ? ' po-recap__choice--keep-case' : '');
        choice.textContent = opts.choice;
        meta.appendChild(choice);
      }
      var price = document.createElement('span');
      price.className = 'po-recap__price';
      price.textContent = opts.price || recapDash;
      meta.appendChild(price);
      row.appendChild(meta);

      row.addEventListener('click', function () {
        if (opts.goto == null) return;
        showStep(opts.goto);
      });
      return row;
    }

    function renderRecap() {
      if (!recapList) return;
      recapList.textContent = '';
      var qty = addonQty();

      steps.forEach(function (step, i) {
        var type = step.dataset.poType;
        var a = answers[i];

        if (type === 'lot-de-2') {
          recapList.appendChild(recapRow({
            name: recapLot,
            choice: a === 'yes' ? recapWith : recapWithout,
            price: recapDash,
            goto: i
          }));
        }

        if (type === 'lot-handle' && !isSkipped(step) && a && a.variantId) {
          var lotGoto = steps.findIndex(function (s) { return s.dataset.poType === 'lot-de-2'; });
          recapList.appendChild(recapRow({
            name: productTitle,
            price: recapDash,
            image: productImage,
            goto: lotGoto >= 0 ? lotGoto : null
          }));
          recapList.appendChild(recapRow({
            name: a.label || recapPoignee,
            price: priceLabel(a.cents, 1),
            image: a.image || '',
            goto: i
          }));
        }

        if (type === 'addon-ask' && a === 'no') {
          recapList.appendChild(recapRow({
            name: stepRecapName(step),
            choice: recapWithout,
            price: recapDash,
            goto: i
          }));
        }

        if (type === 'carre' && !isSkipped(step)) {
          var carreNone = !a || a.value === 'none' || !a.variantId;
          recapList.appendChild(recapRow({
            name: stepRecapName(step),
            choice: carreNone ? recapWithout : (a.label || ''),
            price: carreNone ? recapDash : priceLabel(a.cents, 1),
            keepCase: !carreNone,
            goto: i
          }));
        }

        if (type === 'plaque') {
          recapList.appendChild(recapRow({
            name: recapPlaque,
            choice: a === 'yes' ? recapWith : recapWithout,
            price: recapDash,
            goto: i
          }));
        }

        if (type === 'plaque-type' && !isSkipped(step) && a) {
          recapList.appendChild(recapRow({
            name: recapPlaqueType,
            choice: shortPlaqueType(a.label || ''),
            price: recapDash,
            goto: i
          }));
        }

        if (type === 'plaque-variant' && !isSkipped(step) && a && a.variantId) {
          var variantName = a.label || '';
          if (qty > 1) variantName = variantName + ' x ' + qty;
          recapList.appendChild(recapRow({
            name: variantName,
            price: priceLabel(a.cents, qty),
            image: a.image || '',
            goto: i
          }));
        }
      });
    }

    function showRecap() {
      showingRecap = true;
      closeAllDropdowns();
      steps.forEach(function (step) {
        step.classList.remove('is-active');
      });
      if (recapEl) {
        recapEl.hidden = false;
        recapEl.classList.add('is-active');
      }
      modal.classList.add('is-recap');
      renderRecap();
      showBtn(prevBtn, visibleStepIndexes().length > 0);
      showBtn(nextBtn, false);
      updateProgress();
      updateFooter();
    }

    function advanceAfterAnswer(delay) {
      delay = delay == null ? 180 : delay;
      updateProgress();
      updateFooter();
      var vis = visibleStepIndexes();
      var pos = vis.indexOf(current);
      if (advanceTimer) window.clearTimeout(advanceTimer);
      if (pos !== -1 && pos < vis.length - 1) {
        advanceTimer = window.setTimeout(function () {
          showStep(vis[pos + 1]);
        }, delay);
      } else if (allAnswered()) {
        advanceTimer = window.setTimeout(showRecap, Math.max(delay, 450));
      } else {
        showStep(current);
      }
    }

    function setRadioValue(step, value) {
      step.querySelectorAll('.po-radio').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.dataset.poValue === value);
      });
    }

    function clearStepAnswer(step) {
      var i = steps.indexOf(step);
      if (i !== -1) delete answers[i];
      step.querySelectorAll('.po-radio').forEach(function (btn) {
        btn.classList.remove('is-selected');
      });
      resetDropdownUI(step);
    }

    function clearPlaqueFollowup() {
      steps.forEach(function (step) {
        if (step.dataset.poType === 'plaque-type' || step.dataset.poType === 'plaque-variant') {
          clearStepAnswer(step);
        }
      });
    }

    function clearLotFollowup() {
      steps.forEach(function (step) {
        if (step.dataset.poType === 'lot-handle') clearStepAnswer(step);
      });
    }

    function selectLot(step, value) {
      answers[steps.indexOf(step)] = value;
      setRadioValue(step, value);
      if (value !== 'yes') clearLotFollowup();
      advanceAfterAnswer();
    }

    function clearAddonFollowup(askStep) {
      var askIndex = steps.indexOf(askStep);
      steps.forEach(function (step) {
        if (step.dataset.poRequires === 'addon-yes' && parseInt(step.dataset.poAskStep, 10) === askIndex) {
          clearStepAnswer(step);
        }
      });
    }

    function selectAddonAsk(step, value) {
      answers[steps.indexOf(step)] = value;
      setRadioValue(step, value);
      if (value !== 'yes') clearAddonFollowup(step);
      advanceAfterAnswer();
    }

    function autoSelectSinglePlaqueType() {
      var typeStep = steps.find(function (s) { return s.dataset.poType === 'plaque-type'; });
      var btns = plaqueTypeButtons();
      if (!typeStep || btns.length !== 1) return;
      selectPlaqueType(typeStep, btns[0], true);
    }

    function selectPlaque(step, value) {
      answers[steps.indexOf(step)] = value;
      setRadioValue(step, value);
      if (value === 'no') clearPlaqueFollowup();
      else autoSelectSinglePlaqueType();
      advanceAfterAnswer();
    }

    function selectPlaqueType(step, btn, silent) {
      var index = steps.indexOf(step);
      var prev = answers[index];
      var productId = btn.dataset.poValue;
      if (prev && prev.productId && prev.productId !== productId) {
        var variantStep = steps.find(function (s) { return s.dataset.poType === 'plaque-variant'; });
        if (variantStep) clearStepAnswer(variantStep);
      }
      answers[index] = {
        productId: productId,
        label: btn.dataset.poLabel || ''
      };
      setRadioValue(step, productId);
      syncPlaqueVariantDropdowns();
      if (!silent) advanceAfterAnswer();
    }

    function selectDropdownOption(step, optionEl) {
      var index = steps.indexOf(step);
      var dd = optionEl.closest('.po-dropdown');
      var qty = addonQty();
      var label = optionEl.dataset.poLabel || '';
      var displayLabel = (qty > 1 && step.dataset.poType === 'plaque-variant') ? ('2 x ' + label) : label;
      var img = optionEl.querySelector('img');
      var priceNode = optionEl.querySelector('.po-dropdown__option-price');
      var priceText = optionEl.dataset.poValue === 'none' ? '' : (priceNode ? priceNode.textContent.trim() : '');

      answers[index] = {
        value: optionEl.dataset.poValue,
        label: label,
        cents: optionEl.dataset.poCents || '0',
        variantId: optionEl.dataset.poVariantId || '',
        productId: dd && dd.dataset.poPlaqueProduct ? dd.dataset.poPlaqueProduct : '',
        image: img ? img.getAttribute('src') : ''
      };

      step.querySelectorAll('.po-dropdown__option').forEach(function (opt) {
        opt.classList.toggle('is-selected', opt === optionEl);
      });

      setDropdownValue(dd, displayLabel, priceText);
      closeAllDropdowns();
      advanceAfterAnswer(550);
    }

    function notifyCartAdded() {
      if (document.body.getAttribute('data-po-just-added') !== '1') return;
      document.body.removeAttribute('data-po-just-added');
      var section = document.querySelector('[data-po-visible-count]');
      var count = section ? section.getAttribute('data-po-visible-count') : '';
      document.dispatchEvent(new CustomEvent('ldw:po-added', { detail: { count: count } }));
    }

    function submitCart() {
      if (!allAnswered() || (addBtn && addBtn.disabled)) return;
      var qty = productQty();
      var extrasQty = addonQty();
      var bundleId = 'po-' + String(Date.now());
      var props = collectProperties();
      props._po_bundle = bundleId;
      var items = [{
        id: Number(variantInput.value),
        quantity: qty,
        properties: props
      }].concat(extraItems(extrasQty, bundleId));

      function afterAdd() {
        closeModal();
        resetModal();
        document.body.classList.add('cart-open');
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(notifyCartAdded);
        });
      }

      document.body.setAttribute('data-po-just-added', '1');

      if (window.liquidAjaxCart && typeof window.liquidAjaxCart.add === 'function') {
        window.liquidAjaxCart.add({ items: items }, { lastCallback: afterAdd });
        return;
      }

      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(afterAdd).catch(function (err) {
        console.error('[product-options] add to cart failed', err);
      });
    }

    function preloadPlaqueImages() {
      modal.querySelectorAll('.po-dropdown__thumb').forEach(function (img) {
        var urls = [];
        var src = img.getAttribute('src');
        if (src) urls.push(src);
        var srcset = img.getAttribute('srcset') || '';
        srcset.split(',').forEach(function (part) {
          var url = part.trim().split(/\s+/)[0];
          if (url) urls.push(url);
        });
        urls.forEach(function (url) {
          if (!url || preloadPlaqueImages.seen[url]) return;
          preloadPlaqueImages.seen[url] = true;
          var preload = new Image();
          preload.decoding = 'async';
          preload.src = url;
        });
      });
    }
    preloadPlaqueImages.seen = {};

    function openModal() {
      document.body.classList.remove(
        'cart-open',
        'header-cart-open',
        'autocad-open',
        'stock-request-open',
        'vm-open',
        'contact-open'
      );
      document.body.classList.add('po-open');
      preloadPlaqueImages();
    }

    function closeModal() {
      document.body.classList.remove('po-open');
      closeAllDropdowns();
      if (advanceTimer) window.clearTimeout(advanceTimer);
    }

    function resetModal() {
      answers = {};
      current = 0;
      if (advanceTimer) window.clearTimeout(advanceTimer);
      hideRecap();
      steps.forEach(function (step) {
        step.querySelectorAll('.po-radio').forEach(function (btn) {
          btn.classList.remove('is-selected');
        });
      });
      resetDropdownUI(modal);
      if (qtyInput) qtyInput.value = '1';
      if (priceEl) priceEl.textContent = priceOne;
      if (addBtn) addBtn.disabled = true;
      updateQtySensitiveLabels();
      updateProgress();
      showStep(0);
    }

    function bindDropdown(dd, step) {
      var trigger = dd.querySelector('.po-dropdown__trigger');
      var list = dd.querySelector('.po-dropdown__list');

      if (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var willOpen = !dd.classList.contains('is-open');
          closeAllDropdowns();
          if (willOpen) {
            preloadPlaqueImages();
            dd.classList.add('is-open');
            if (list) list.hidden = false;
            trigger.setAttribute('aria-expanded', 'true');
          }
        });
      }

      dd.querySelectorAll('.po-dropdown__option').forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          selectDropdownOption(step, opt);
        });
      });
    }

    document.querySelectorAll('[data-po-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });

    modal.querySelectorAll('[data-po-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    var backdrop = document.getElementById('po-backdrop');
    if (backdrop) backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('po-open')) closeModal();
    });

    steps.forEach(function (step) {
      step.querySelectorAll('.po-radio').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var type = step.dataset.poType;
          if (type === 'plaque') selectPlaque(step, btn.dataset.poValue);
          else if (type === 'plaque-type') selectPlaqueType(step, btn);
          else if (type === 'lot-de-2') selectLot(step, btn.dataset.poValue);
          else if (type === 'addon-ask') selectAddonAsk(step, btn.dataset.poValue);
        });
      });

      step.querySelectorAll('[data-po-dropdown]').forEach(function (dd) {
        bindDropdown(dd, step);
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-po-dropdown]')) closeAllDropdowns();
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var vis = visibleStepIndexes();
        var pos = vis.indexOf(current);
        if (pos !== -1 && pos < vis.length - 1 && answers.hasOwnProperty(current)) {
          showStep(vis[pos + 1]);
        } else if (allAnswered()) {
          showRecap();
        }
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var vis = visibleStepIndexes();
        if (showingRecap) {
          if (vis.length) showStep(vis[vis.length - 1]);
          return;
        }
        var pos = vis.indexOf(current);
        if (pos > 0) showStep(vis[pos - 1]);
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        submitCart();
      });
    }

    modal.querySelectorAll('[data-po-restart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        resetModal();
      });
    });

    if ('requestIdleCallback' in window) {
      requestIdleCallback(preloadPlaqueImages, { timeout: 800 });
    } else {
      setTimeout(preloadPlaqueImages, 0);
    }

    resetModal();
  }
})();
